import { useCallback, useEffect, useState } from 'react';

import { listProjects } from '@/api/projects';
import { buildTree } from '@/lib/build-tree';
import type { Project, ProjectNode } from '@/types/models';

interface State {
  flat: Project[];
  tree: ProjectNode[];
  loading: boolean;
  error: string | null;
}

export function useProjects(refreshKey: number) {
  const [state, setState] = useState<State>({
    flat: [],
    tree: [],
    loading: true,
    error: null,
  });

  const refetch = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const { projects } = await listProjects();
      setState({ flat: projects, tree: buildTree(projects), loading: false, error: null });
    } catch (err) {
      setState({ flat: [], tree: [], loading: false, error: (err as Error).message });
    }
  }, []);

  useEffect(() => {
    void refetch();
  }, [refetch, refreshKey]);

  return { ...state, refetch };
}
